// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rotom: PokeData = {
  "id": 479,
  "name": "rotom",
  "height": 3,
  "weight": 3,
  "base_experience": 154,
  "types": [
    PokeType.ELECTRIC,
    PokeType.GHOST
  ],
  "api_moves": [
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "thunder",
    "double-team",
    "confuse-ray",
    "substitute",
    "shadow-ball",
    "uproar",
    "charge",
    "trick",
    "astonish",
    "shock-wave",
    "discharge",
    "charge-beam",
    "ominous-wind",
    "electro-ball",
    "hex"
  ],
  "moves": [
    "thunder-shock",
    "thunderbolt",
    "thunder",
    "confuse-ray",
    "shadow-ball",
    "curse",
    "spectral-snatch",
    "soul-sacrifice",
    "shadow-dagger",
    "zap-cannon",
    "shadow-sneak",
    "poltergeist",
    "thunder-punch"
  ],
  "evolution_chain": {
    "id": 240,
    "item": null,
    "species": [
      {
        "name": "rotom",
        "order": 480,
        "types": [
          PokeType.ELECTRIC,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 102,
    "speed": 146,
    "ability_power": 152
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
